export default __webpack_public_path__ + "static/media/CL12.1.3ca10d47.mp3";